<template>
  <div>
    <div v-if="!feedbackOption || feedbackOption">
      <button
        class="newHelpButton dark:text-white"
        style="float: right"
        v-on:click="feedbackClicked"
        aria-label="Questions or Feedback"
      >
        <svg
          class="newHelpSVG"
          width="40"
          height="45"
          viewBox="0 0 33 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="16.5" cy="16.5" r="16.5" fill="#DFDEF8" />
          <path
            d="M25 17C25 21.4193 21.418 25 17 25C12.582 25 9 21.4193 9 17C9 12.5833 12.582 9 17 9C21.418 9 25 12.5833 25 17ZM17.2147 11.6452C15.4567 11.6452 14.3355 12.3857 13.455 13.7019C13.341 13.8724 13.3791 14.1024 13.5426 14.2263L14.6619 15.075C14.8298 15.2024 15.0691 15.1721 15.1995 15.0066C15.7758 14.2757 16.1709 13.8518 17.048 13.8518C17.707 13.8518 18.5221 14.276 18.5221 14.915C18.5221 15.3981 18.1233 15.6462 17.4726 16.011C16.7138 16.4364 15.7097 16.9658 15.7097 18.2903V18.4194C15.7097 18.6331 15.883 18.8065 16.0968 18.8065H17.9032C18.117 18.8065 18.2903 18.6331 18.2903 18.4194V18.3764C18.2903 17.4582 20.9737 17.42 20.9737 14.9355C20.9737 13.0645 19.0329 11.6452 17.2147 11.6452ZM17 19.6452C16.1818 19.6452 15.5161 20.3108 15.5161 21.129C15.5161 21.9472 16.1818 22.6129 17 22.6129C17.8182 22.6129 18.4839 21.9472 18.4839 21.129C18.4839 20.3108 17.8182 19.6452 17 19.6452Z"
            fill="#2F2E41"
          />
        </svg>
      </button>
      <div
        v-on:click="darkModeToggle()"
        class="cursor-pointer"
        style="display: inline-flex"
      >
        <div v-if="$store.state.darkMode">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="darkmodeHeader"
            style="width: 47px; height: 47px"
          >
            <path
              d="M15.413 10.0217V8M15.413 23.5V21.4783M10.0795 21.6178L11.5091 20.1882M19.5143 11.5091L20.9439 10.0796M19.3169 20.1882L20.7465 21.6178M9.8821 10.0796L11.3117 11.5091M8 16.087H10.0217M21.4783 16.087H23.5"
              stroke="white"
              stroke-linecap="round"
            />
            <circle cx="15.7501" cy="15.75" r="4.71739" fill="white" />
          </svg>
        </div>
        <div v-else>
          <svg
            class="darkmodeHeader"
            style="width: 47px; height: 47px"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M23.9737 18.4014C24.0936 18.1359 23.7791 17.8967 23.5224 18.0367C22.5324 18.5766 21.3956 18.8837 20.1866 18.8837C16.3514 18.8837 13.2423 15.7934 13.2423 11.9814C13.2423 10.7043 13.5913 9.50814 14.1997 8.48209C14.3483 8.2314 14.1174 7.91173 13.8467 8.02263C11.0022 9.18811 9 11.9713 9 15.2192C9 19.5164 12.5048 23 16.8281 23C20.0108 23 22.7499 21.1121 23.9737 18.4014Z"
              fill="#3F3D56"
            />
          </svg>
        </div>
      </div>
    </div>

    <div v-if="feedbackOption">
      <div class="continuumDialog dark:bg-purple-600 border-2 dark:text-white">
        <button
          v-on:click="feedbackClosed"
          class="cursor-pointer"
          style="float: right; position: relative"
          aria-label="Close"
        >
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="18" cy="18" r="18" fill="#F2F2F2"></circle>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.3969 12.2496C11.5347 12.1117 11.7582 12.1117 11.8961 12.2496L23.7513 24.1048C23.8891 24.2426 23.8891 24.4661 23.7513 24.604C23.6134 24.7418 23.3899 24.7418 23.2521 24.604L11.3969 12.7488C11.259 12.6109 11.259 12.3874 11.3969 12.2496Z"
              fill="#0C0707"
              stroke="#3F3D56"
              stroke-linecap="round"
            ></path>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.2496 24.6041C11.1117 24.4662 11.1117 24.2427 11.2496 24.1049L23.1048 12.2497C23.2426 12.1119 23.4661 12.1119 23.604 12.2497C23.7418 12.3876 23.7418 12.6111 23.604 12.7489L11.7488 24.6041C11.6109 24.7419 11.3874 24.7419 11.2496 24.6041Z"
              fill="#0C0707"
              stroke="#3F3D56"
              stroke-linecap="round"
            ></path>
          </svg>
        </button>
        <h2 class="text-lg font-medium">Questions/Feedback</h2>
        <br />
        <p class="text-x">
          We are continuously looking for ways to improve the Wellness Services
          Navigator. If you have any questions, feedback, or comments, please
          contact
          <a
            class="
              text-link-blue
              font-bold
              pb-0
              border-b
              dark:text-link-light-blue
            "
            href="mailto:wellness@carleton.ca"
            >wellness@carleton.ca</a
          >.
        </p>
      </div>

      <div v-on:click="feedbackClosed" class="modalOverlayClose"></div>
    </div>
  </div>
</template>

<script>
import store from "../store";
export default {
  name: "HelpDialog",

  data() {
    return {
      feedbackOption: false,
      darkSide: false,
    };
  },
  mounted() {
    this.checkDisplayMode();
  },
  methods: {
    feedbackClicked() {
      this.feedbackOption = true;
    },
    feedbackClosed() {
      this.feedbackOption = false;
    },
    checkDisplayMode() {
      if (localStorage.theme === "dark") {
        document.documentElement.classList.add("dark");
        this.darkSide = true;
        store.commit("changeDarkMode", this.darkSide);
      } else {
        document.documentElement.classList.remove("dark");
        this.darkSide = false;
        store.commit("changeDarkMode", this.darkSide);
      }
    },
    darkModeToggle() {
      store.commit("changeDarkModeSwap");
      const currMode = store.getters.darkModeState;
      this.darkSide = !this.darkSide;
      let classClass = "";
      if (currMode) {
        classClass = "dark";
        localStorage.theme = "dark";
      } else {
        classClass = "";
        localStorage.removeItem("theme");
      }
      var root = document.getElementsByTagName("html")[0];
      root.setAttribute("class", classClass);
    },
  },
};
</script>

<style lang="css" scoped>
.newHelpButton:after {
  content: "Questions/Feedback";
  font-size: 14px;
  font-weight: 500;
  padding: 11px;
  padding-left: 7px;
}
.continuumDialog {
  @apply fixed p-8 bg-white  shadow-lg z-50;
  margin-left: 1rem;
  margin-right: 1rem;
  text-align: left;
  top: 50%;
  left: 0;
  right: 0;
  margin: auto;
  transform: translateY(-50%);
  width: 50%;
  border-radius: 20px;
}

@media only screen and (max-width: 768px) {
  .continuumDialog {
    width: 75%;
  }
}

@media only screen and (max-width: 640px) {
  .continuumDialog {
    max-height: calc(100vh - 100px);
    overflow-y: auto;
    position: fixed;
    @apply p-8;
  }

  .newHelpButton:after {
    content: none;
  }
}
</style>
